import { Component, Vue, Prop } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component<TabLabels>({})
export default class TabLabels extends Vue {
  // https://github.com/kaorun343/vue-property-decorator

  // To function properly, requires the following to be set on component:
  // v-model

  // #region @VModel

  // When using 'to' on v-tab, always use a path since vuetify will resolve RawLocation to the path (e.g. /clients/client)
  // When not using 'to' on v-tab, the value will be the index (starting with 0)

  @Prop({ default: '' })
  protected value!: number | string;

  protected get internalValue(): number | string {
    return this.value;
  }

  protected set internalValue(value: number | string) {
    this.$emit('input', value);
  }

  // #endregion

  // #region @Props

  @Prop({ default: () => [] })
  protected tabs!: TabLabelInterface[];

  @Prop({ default: true })
  protected navigateToStartTab!: boolean;

  // #endregion

  // #region Lifecycle hooks

  protected created(): void {
    this.onCreated();
  }

  // #endregion

  // #region Lifecycle hook handlers

  protected onCreated(): void {
    this.clickStartTab();
  }

  // #endregion

  // #region Helpers

  protected clickStartTab(): void {
    if (
      typeof this.internalValue === 'number' // When the activeTab is a number (when not using 'to' on a v-tab), vuetify performs the click for us
      || this.navigateToStartTab === false // Or when navigateToStartTab is disabled
      || this.tabPaths.includes(this.$route.fullPath) // Or if we're already on one of the tabs
      || ! this.tabPaths.includes(this.internalValue) // Or if the activeTab is not found
    ) {
      return; // early return
    }

    this.$router.replace(this.internalValue);
  }

  // #endregion

  // #region Getters

  protected get tabPaths(): string[] {
    return this.tabs
      .filter((tab): boolean => tab.to !== undefined) // Make a list of tabs that have 'to'
      .map((tab): string => (typeof tab.to === 'string' ? tab.to : this.$router.resolve(tab.to || '').href)); // Simplify to a list of paths
  }

  // #endregion
}

// #region Interfaces

export interface TabLabelInterface {
  title: string;
  to?: RawLocation;
}

// #endregion
